export default {
  current: 'Aktuálne',
  noActiveRecipe: 'Na tejto peci nie je aktívny žiaden recept.',
};
